//
//
//
//

import SectionContainer from "@/components/common/section/SectionContainer";
import OrderTrackerPage from "@/components/pages/orderTracker/index";
import staticPagesLang from "~/mixins/staticPagesLang";

export default {
    name: "OrderTracker",
    components: {OrderTrackerPage, SectionContainer},
    mixins: [
        staticPagesLang
    ],
}
